module.exports = __webpack_public_path__ + "media/images/creator/logo-8abe294f0bfad04fe66655e3015797eb.png";